module.exports = __webpack_public_path__ + "static/media/twitterIcon.e9c66d05.svg";